import type { CrawlerEntitlementStatus } from "../shared/entitlements";

export function CreditBalance({ clientId, status, loading, error, canManageBilling, onRefresh }: {
  clientId: string;
  status: CrawlerEntitlementStatus | null;
  loading: boolean;
  error: boolean;
  canManageBilling: boolean;
  onRefresh: () => void;
}) {
  const credits = status?.clientId === clientId ? status.credits : undefined;
  const format = (value: string) => new Intl.NumberFormat(undefined, { maximumFractionDigits: 6 }).format(Number(value));
  const balance = loading ? "Checking…"
    : error ? "Unavailable"
    : credits?.state === "available" && credits.available !== null ? format(credits.available)
    : credits?.state === "unlimited" ? "Unlimited"
    : credits?.state === "terms_required" ? "Terms acceptance required"
    : credits?.state === "bypassed" ? "Accounting paused"
    : "Unavailable";
  return (
    <div className="credit-balance" aria-label="Available organisation credits">
      <span>Available credits · {clientId}</span>
      <strong role="status" aria-live="polite">{balance}</strong>
      {!loading && !error && credits?.reserved && Number(credits.reserved) > 0 && (
        <small>{format(credits.reserved)} reserved by running operations</small>
      )}
      {(error || credits?.state === "unavailable") && <small>Credit status could not be loaded. Try refreshing.</small>}
      <div className="credit-balance-actions">
        <button type="button" className="button button-small" disabled={loading} onClick={onRefresh}>Refresh credits</button>
        {canManageBilling && (
          <a href={`https://billing.future-demand.com/app/org/${encodeURIComponent(clientId)}`} target="_blank" rel="noreferrer">Manage credits in Billing</a>
        )}
      </div>
    </div>
  );
}
